export const TwitchIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
    <g fill={props.color || '#707B8F'}>
      <path d="M5 0 1.43 3.571V16.43h4.285V20l3.571-3.571h2.857L18.573 10V0H5Zm12.143 9.286-2.857 2.857H11.43l-2.5 2.5v-2.5H5.715V1.429h11.428v7.857Z" />
      <path d="M15 3.929h-1.428v4.285h1.429V3.93ZM11.072 3.929H9.644v4.285h1.428V3.93Z" />
    </g>
  </svg>
);
